import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import AuthMenu from 'game/app/components/layout/auth-menu';
import {Link, NavLink, Route, Switch, withRouter} from "react-router-dom";
import {NavbarToggler, Collapse} from "reactstrap";
import assets from 'game/app/assets';
import GameComponent from "game/app/components/game/game-component";
import VideoBtn from "game/app/components/video-btn";

class Navbar extends GameComponent {

    constructor(params) {
        super(params);
        this.state = { toggle: false }
    }

    toggle = () => {
        this.setState({...this.state, toggle: !this.state.toggle});
    };

    hide = () => {
        this.setState({...this.state, toggle: false});
    };

    gameInfo() {
        let instance = this.props.gameInstance.instance;
        let chechtaky = this.getInstanceProperty('STATS_CHECHTAKY');

        return (
            <ul className='resources'>
                <li>
                    <img src={assets.resources.chechtaky}/>
                    <div>Chechtáky</div>
                    <div className='value'><span className={(chechtaky < 0 ? 'text-danger' : '')}>{ chechtaky }</span></div>
                </li>
            </ul>
        );
    }

    render() {
        let instance = this.props.gameInstance.instance;
        const instanceId = instance.id;

        return (
            <nav className="navbar page-header navbar-light navbar-expand-lg fixed-top bg-white">
                <div className='upper-menu'>
                    <Link to='/' className="navbar-brand"><img src={assets.rozpoctisito} id='logo'/></Link>
                    <NavbarToggler onClick={this.toggle}/>
                    { this.gameInfo() }
                    <div className={`collapse navbar-collapse ${this.state.toggle ? 'show' : ''}`}>
                        <AuthMenu hide={this.hide}/>
                    </div>
                </div>
                <div className='bottom-menu'>
                    <div className='info'>Není ti jasné, jak hra probíhá? <Link to={{ pathname: `/pravidla`, state: { rules: 'primary' }}}>Přečti si pravidla</Link>.</div>
                    <Collapse isOpen={this.props.toggle} navbar>
                        <ul className='navbar-nav'>
                            <li className='nav-item'><NavLink className='nav-link' to={`/game/${instanceId}/ukoly`}>Úkoly</NavLink></li>
                            <li className='nav-item'><NavLink className='nav-link' to={`/game/${instanceId}/leaderboard`}>Leaderboard</NavLink></li>
                        </ul>
                    </Collapse>
                </div>
            </nav>
        )
    }
}


function mapStateToProps(state,ownProps) {
    return {
        gameInstance: state.gameInstance,
        auth: state.auth,
        sidebarToggle: ownProps.sidebarToggle,
        sidebarToggleMobile: ownProps.sidebarToggleMobile
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(Navbar));
